var map = {
	"./year_2015.svg": [
		8151,
		151
	],
	"./year_2016.svg": [
		9466,
		466
	],
	"./year_2017.svg": [
		2158,
		158
	],
	"./year_2018.svg": [
		7277,
		277
	],
	"./year_2019.svg": [
		7262,
		262
	],
	"./year_2020.svg": [
		760,
		760
	],
	"./year_2021.svg": [
		128,
		128
	],
	"./year_2022.svg": [
		6509,
		509
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4147;
module.exports = webpackAsyncContext;